<template>
  <div id="phone">
    <div class="title">更改手机号</div>
    <ul class="from">
      <li class="item">
        <div class="key">原手机号</div>
        <div class="value">{{ userInfo.user.username }}</div>
      </li>
      <!--      <li class="item">-->
      <!--        <div class="key">手机验证码</div>-->
      <!--        <div class="value">-->
      <!--          <Input v-model="phoneKey" placeholder="" style="width: 230px" />-->
      <!--          <div @click="keyClick" :class="keyFlag ? 'getCode' : 'nullCode'">-->
      <!--            {{ keyButton }}-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </li>-->
      <li class="item">
        <div class="key">新手机号</div>
        <div class="value">
          <Input v-model="newPhone" placeholder=""/>
        </div>
      </li>
      <li class="item">
        <div class="key">新手机验证码</div>
        <div class="value">
          <Input v-model="newPhoneKey" placeholder=""/>
          <Button
            @click="newKeyClick"
            v-throttleClick
            :class="['getCode', !newKeyFlag ? 'nullCode' : '']"
          >
            {{ newKeyButton }}
          </Button>
        </div>
      </li>
      <li class="item">
        <div class="key">设置新密码</div>
        <div class="value">
          <Input
            v-model="setPwd"
            class="no-autofill-pwd"
          />
        </div>
      </li>
    </ul>
    <div class="btn">
      <div @click="closeAlert" class="close">取消</div>
      <Button v-throttleClick @click="affirm" class="affirm">确认</Button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "phone",
  computed: {
    ...mapState(["userInfo"]),
  },
  filters: {
    jiami(val) {
      let reg = /(\d{3})\d{4}(\d{4})/; //正则表达式
      return val.replace(reg, "$1****$2");
    },
  },
  data() {
    return {
      phoneKey: "",
      newPhone: "",
      newPhoneKey: "",
      keyButton: "获取手机验证码",
      timer: null,
      keyFlag: true,
      newKeyButton: "获取新手机验证码",
      newKeyFlag: true,
      newTimer: null,
      setPwd: "",
    };
  },
  methods: {
    async affirm() {
      let obj = {
        mobile: this.newPhone,
        validateCode: this.newPhoneKey,
        pwd: this.setPwd,
      };
      if(this.newPhone === '') {
        this.$Message.warning('请输入新手机号');
        return
      }
      if(this.newPhoneKey === '') {
        this.$Message.warning('请输入验证码');
        return
      }
      if (isNaN(+this.newPhoneKey)) {
        this.$Message.warning('请输入正确的验证码');
        return          
      }
      if(this.setPwd === '') {
        this.$Message.warning('请输入新密码');
        return
      }
      const pasRegex = /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/
      if(!pasRegex.test(this.setPwd)){
        this.$Message.error('密码由数字、字符和符号至少两种组成，且6-16个字符之间！')
        return
      }
      const res = await this.$apis.userServe.setPhone(obj);
      if (res.resultCode == 200) {
        this.$Message.success(res.resultDesc);
        this.$emit("setAlert");
      } else {
        this.$Message.error(res.resultDesc);
      }
    },
    closeAlert() {
      this.$emit("setAlert");
    },
    destroy() {
      clearInterval(this.timer);
      this.keyFlag = true;
      this.keyButton = "获取手机验证码";
    },
    newDestroy() {
      clearInterval(this.newTimer);
      this.newKeyFlag = true;
      this.newKeyButton = "获取验证码";
    },
    keyClick() {
      if (!this.keyFlag) {
        return;
      }
      this.keyFlag = !this.keyFlag;
      let num = 60;
      this.sendCode("old");
      this.keyButton = `${num}秒后重新获取`;
      this.timer = setInterval(() => {
        if (num <= 0) {
          this.destroy();
        } else {
          this.keyButton = `${--num}秒后重新获取`;
        }
      }, 1000);
    },
    sendCode(type) {
      let obj = {
        phone: type === "new" ? this.newPhone : this.userInfo.user.username,
        adapter: "reset_pwd",
      };
      this.$apis.loginServe.getCode(obj);
    },
    newKeyClick() {
      if (!this.newKeyFlag) {
        return;
      }
      if (this.newPhone === '') {
        this.$Message.warning("请输入新手机号");
        return;
      }
      const pattern = /^1\d{10}$/;
      if (!pattern.test(this.newPhone)) {
        this.$Message.error("手机号格式错误");
        return;
      }
      if (this.newPhone === this.userInfo.user.username) {
        this.$Message.error("请输入新手机号");
        return;
      }
      const pasRegex = /(?!.*[\u4E00-\u9FA5\s])(?!^[a-zA-Z]+$)(?!^[\d]+$)(?!^[^a-zA-Z\d]+$)^.{6,16}$/
      if(!pasRegex.test(this.setPwd)){
        this.$Message.error('密码由数字、字符和符号至少两种组成，且6-16个字符之间！')
        return
      }
      this.sendCode("new");
      this.newKeyFlag = !this.newKeyFlag;
      let num = 60;
      this.newKeyButton = `${num}秒后重新获取`;
      this.newTimer = setInterval(() => {
        if (num <= 0) {
          this.newDestroy();
        } else {
          this.newKeyButton = `${--num}秒后重新获取`;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
#phone {
  //padding-left: 50px;
  padding-top: 38px;
  padding: 38px 50px 0 40px;
  .btn {
    margin-top: 34px;
    width: 100%;
    height: 50px;
    //background: pink;
    display: flex;
    justify-content: center;
    .close {
      text-align: center;
      line-height: 38px;
      width: 72px;
      height: 38px;
      background: #ffffff;
      border: 1px solid #d2d2d2;
      border-radius: 8px;
      margin-right: 13px;
      cursor: pointer;
    }
    .affirm {
      margin-left: 13px;
      text-align: center;
      line-height: 38px;
      width: 70px;
      height: 36px;
      color: #fff;
      background: #007fff;
      border-radius: 8px;
      cursor: pointer;
    }
  }
  .from {
    margin-top: 30px;
    .item {
      margin-top: 10px;
      margin-bottom: 10px;
      //background: pink;
      height: 32px;
      //width: 600px;
      display: flex;
      .key {
        width: 100px;
        line-height: 32px;
        text-align: right;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
      }
      .value {
        display: flex;
        flex: 1;
        line-height: 32px;
        margin-left: 20px;
        .getCode {
          margin-left: 20px;
          padding: 0;
          border: none;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #007fff;
          cursor: pointer;
        }
        &::v-deep .ivu-input-wrapper {
          flex: 1;
        }
        .nullCode {
          color: #333;
        }
        .no-autofill-pwd {
          ::v-deep .ivu-input-default {
            -webkit-text-security:disc!important;
          }
        }
      }
    }
  }
  .title {
    margin-left: 10px;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
}
</style>
